import { render, staticRenderFns } from "./Indictment.vue?vue&type=template&id=ab114308&scoped=true&"
import script from "./Indictment.vue?vue&type=script&lang=js&"
export * from "./Indictment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab114308",
  null
  
)

export default component.exports